import ErrorOutlineIcon from './ErrorOutlineIcon'

export default ErrorOutlineIcon
